import type * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { getMediaCSSVariable } from '@/hooks/responsive/useResponsiveConstants';

type SecondaryHeaderType = Record<string, unknown>;

const Container = styled.div`
  ${tw`flex flex-col justify-end self-center flex-wrap flex-shrink-0 sm:flex-row sm:self-center pl-2 gap-x-3`}
  @media (max-width: ${getMediaCSSVariable('--screen-sm')}) {
    > :nth-child(1) {
      order: 3;
    }
    > :nth-child(3) {
      order: 1;
      margin-top: 0.2rem;
    }
  }
`;

export const SecondaryHeader: React.FunctionComponent<SecondaryHeaderType> = ({
  children,
}) => {
  return <Container>{children}</Container>;
};
